import React from "react";

/** Shared MUI OTP field theme props for auth pages */
export const authOtpSx = {
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  gap: "8px",
  mb: 1,
};

export const authOtpFieldProps = {
  sx: {
    flex: 1,
    "& .MuiOutlinedInput-root": {
      borderRadius: "var(--radius-sm, 4px)",
      height: "42px",
      fontWeight: 700,
      background: "var(--surface-color)",
      color: "var(--text-dark)",
      "& fieldset": { borderColor: "var(--border-color)" },
      "&:hover fieldset": { borderColor: "var(--primary-color)" },
      "&.Mui-focused fieldset": { borderColor: "var(--primary-color)" },
    },
    "& .MuiOutlinedInput-input": {
      color: "var(--text-dark)",
    },
  },
  inputProps: {
    style: { textAlign: "center", fontSize: 18 },
    inputMode: "numeric",
  },
};

export const AuthField = ({
  label,
  required,
  children,
  className = "",
}) => (
  <label className={`ds-auth-field ${className}`.trim()}>
    {label ? (
      <span className="ds-label">
        {label}
        {required ? <span className="ds-auth-required"> *</span> : null}
      </span>
    ) : null}
    {children}
  </label>
);


export const AuthPasswordInput = ({
  value,
  onChange,
  show,
  onToggle,
  placeholder = "********",
  disabled = false,
  id,
}) => (
  <div className="ds-auth-password">
    <input
      id={id}
      name="password"
      type={show ? "text" : "password"}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      className="ds-input ds-auth-password__input"
      autoComplete="current-password"
      required
    />
    <button
      type="button"
      className="ds-auth-password__toggle"
      onClick={onToggle}
      tabIndex={-1}
      aria-label={show ? "Hide password" : "Show password"}
    >
      {show ? "Hide" : "Show"}
    </button>
  </div>
);


// export const AuthPasswordInput = ({
//   value,
//   onChange,
//   show,
//   onToggle,
//   placeholder = "********",
//   disabled = false,
//   id,
// }) => (
//   <div className="ds-auth-password">
//     <input
//       id={id}
//       type={show ? "text" : "password"}
//       value={value}
//       onChange={onChange}
//       placeholder={placeholder}
//       disabled={disabled}
//       className="ds-input ds-auth-password__input"
//       autoComplete="current-password"
//     />
//     <button
//       type="button"
//       className="ds-auth-password__toggle"
//       onClick={onToggle}
//       tabIndex={-1}
//       aria-label={show ? "Hide password" : "Show password"}
//     >
//       {show ? "Hide" : "Show"}
//     </button>
//   </div>
// );


